export const EMPTY = 'There are no courses.';
